/**
 * Route guard for the support console — THEME 8 Phase 2.
 *
 * Renders its children only when a staff session exists; otherwise redirects to
 * /support/login. This is intentionally independent of the tenant ProtectedRoute /
 * AuthContext — the support surface has its own ephemeral session (support/staffApi).
 *
 * @module support/SupportRoute
 */

import type { ReactElement, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { getStaffToken } from './staffApi';

export function SupportRoute({ children }: { children: ReactNode }): ReactElement {
  if (!getStaffToken()) {
    return <Navigate to="/support/login" replace />;
  }
  return <>{children}</>;
}
